export default {
      id: "i-instagram-usage",
      viewBox: "2 -3 20 30",
      url: __webpack_public_path__ + "img/sprite.svg#i-instagram",
      toString: function () {
        return this.url;
      }
    }